__turbopack_context__.v({
  "container": "GeneralEventPanelInfo-module-scss-module__lNJkJG__container",
  "content": "GeneralEventPanelInfo-module-scss-module__lNJkJG__content",
  "ctaButtonWrapper": "GeneralEventPanelInfo-module-scss-module__lNJkJG__ctaButtonWrapper",
  "date": "GeneralEventPanelInfo-module-scss-module__lNJkJG__date",
  "label": "GeneralEventPanelInfo-module-scss-module__lNJkJG__label",
});
